import { useEffect, useState } from "react";
import { fetchSubjects } from "../utils/api";

export default function Subjects() {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSubjects = async () => {
      try {
        const data = await fetchSubjects();
        setSubjects(data);
      } catch (err) {
        console.error("Failed to load subjects", err);
      } finally {
        setLoading(false);
      }
    };
    loadSubjects();
  }, []);

  return (
    <div className="users-page">
      {/* Header */}
      <div className="page-header">
        <h1 className="page-title">Subjects</h1>
        <p className="page-subtitle">
          Manage Torah content categories (fixed system subjects)
        </p>
      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table className="users-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Subject</th>
              <th>Slug</th>
              <th>Hebrew</th>
              <th>Yiddish</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="empty">
                  Loading subjects…
                </td>
              </tr>
            ) : subjects.length === 0 ? (
              <tr>
                <td colSpan="6" className="empty">
                  No subjects found
                </td>
              </tr>
            ) : (
              subjects.map((s, index) => (
                <tr key={s.id}>
                  <td>{index + 1}</td>

                  <td>
                    <strong>{s.title_en}</strong>
                  </td>

                  <td className="text-gray-500">{s.slug}</td>

                  <td dir="rtl">{s.title_he}</td>

                  <td dir="rtl">{s.title_yi}</td>

                  <td>
                    <a
                      href={`/topics/${s.slug}`}
                      className="action-btn activate"
                    >
                      Manage Topics
                    </a>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
